export default "__VITE_ASSET__d4c47eff__"